export const HIDDEN_PATHS = {
  navbar: ["/consent", "/validate"],
  sidebar: [
    "/consent",
    "/validate",
    "/signup",
    "/login",
    "forgotPassword",
    "/unauthorized",
  ],
  mainContent: [
    "/consent",
    "/validate",
    "/signup",
    "/login",
    "forgotPassword",
    "/unauthorized",
  ],
};
